import { useMemo } from 'react';
import { getInitials } from '@agentguru/helpers';
import { useMe } from './useMe';
export function useUserNameInitials() {
    var me = useMe().data;
    return useMemo(function () {
        return getInitials("".concat(me === null || me === void 0 ? void 0 : me.first_name, " ").concat(me === null || me === void 0 ? void 0 : me.last_name));
    }, [me]);
}
